/*
* 语言文件 en：英文
* */
export const lang_en = {
    //首页公共头部最顶部
    '您好，欢迎来到': 'Hello, welcome to',
    '退出': 'drop out',
    '注册': 'registered',
    '商城首页': 'Mall Home',
    '待支付订单': 'Orders to be paid',
    '待收货订单': 'Inbound orders',
    '待评价订单': 'Orders to be evaluated',
    '个人中心': 'Individual centers',
    '商品收藏': 'Collection of goods',
    '店铺收藏': 'shop collection',
    '我的账户': 'my account',
    '服务中心': 'Service Center',

    //登录页面
    '手机登录': 'login by phone',
    '账号登录': 'Account login',
    '还没注册？': 'Not registered?',
    '去注册': 'To register',
    '账号为4~16位字母、数字或下划线': 'Account number from 4 to 16 letters, digits, or underscores',
    '登录': 'log in',
    '请输入密码': 'Please enter your password',
    '立即注册': 'Sign up now',
    '忘记密码': 'Forgot password',
    '请输入账号/手机号': 'Please enter the account number / mobile phone number',
    '请输入手机号': 'Please enter phone number',
    '请输入验证码': 'please enter verification code',
    '获取验证码': 'get verification code',
    's后获取': 'After obtaining s',
    '请输入正确的账号/手机号': 'Please enter the correct account number / mobile phone number',

    //忘记密码页面
    '想起密码？': 'Remember your password?',
    '去登录': 'To log',
    '找回密码': 'Forgot your password',

    //注册页面
    '已有账号？': 'Have an account?',
    '已有账号，去登录': 'Have an account, log in to',
    '注册账号': 'Register an account',
    '请输入图形验证码': 'Please input pattern codes',
    '我同意': 'I agree',
    '《用户注册协议及隐私政策》': '"User Registration Agreement and Privacy Policy"',
    '《用户注册协议》': '"User Agreement"',
    '《隐私政策》': '"Privacy Agreement"',

    //注册协议页面
    '我已知悉？': 'I understand that?',

    //文章，商品分类
    '暂无数据': 'No data',
    '首页': 'Home',
    '文章': 'article',
    '文章分类': 'Article Category',
    '最新文章': 'latest articles',
    '搜索': 'search for',
    '默认': 'default',
    '人气': 'Popular',
    '成交量': 'Volume',
    '请输入店铺名称': 'Please enter the shop name',

    //商品列表
    '综合': 'Comprehensive',
    '评论数': 'Reviews',
    '商品类型': 'Product Types',
    '仅显示有货': 'Only goods',
    '仅平台自营': 'Only self-platform',
    '分类': 'classification',
    '筛选结果': 'Screening results',
    '包含分类': 'Categorical',
    '清空': 'Empty',
    '更多选项': 'more options',

    //商品详情页面
    '自营': 'Self',
    '联系客服': 'Contact Customer Service',
    '已关注': 'It has been concern',
    '关注店铺': 'Watch shops',
    '价格': 'price',
    '销量': 'Sales',
    '优惠券': 'coupon',
    '促销': 'Promotion',
    '查看详情': 'see details',
    '配送至': 'ship to',
    '请选择地址': 'Please select the address',
    '运费': 'Freight',
    '免运费': 'Freight Free',
    '数量': 'The number',
    '库存': 'in stock',
    '立即购买': 'Buy now',
    '购物车': 'shopping cart',
    '已收藏': 'collected',
    '收藏': 'Collection',
    '分享': 'share it',
    '看了又看': 'Read and reread',
    '店铺等级': 'Shop class',
    '商品评价': 'product review',
    '物流评价': 'Logistics evaluation',
    '售后服务': 'Service',
    '进入店铺': 'enter a shop',
    '店铺推荐': 'Shop recommended',
    '高': 'high',
    '低': 'low',
    '中': 'in',
    '取消关注': 'unsubscribe',
    '热门收藏': 'Popular',
    '已售': 'Sold',
    '商品详情': 'product details',
    '评价': 'Evaluation',
    '商品服务': 'Goods Services',
    '店铺热销': 'Shops selling',
    '手机下单': 'Phone orders',
    '加入购物车': 'add to Shopping Cart',
    '品牌': 'Brand',
    '查看全部': 'view all',
    '收起全部': 'Contract All',
    '评分': 'score',
    '好评率': 'Favorable rate',
    '全部': 'All',
    '有图': 'There are pictures',
    '好评': 'Praise',
    '中评': 'Average',
    '差评': 'Bad review',
    '商品已下架': 'Merchandise off the shelf',
    '库存不足': 'Inventory shortage',
    '该商品暂无评论~': 'No comment this product ~',
    '暂无相关商品': 'No related products',
    '库存不足！': 'Inventory shortage!',
    '超过购买上限!': 'Exceed the purchase limit!',
    '未登录，请先登录!': 'Not logged in, please login!',
    '加入购物车成功': 'Add to Cart successful',
    '暂无商品服务~': 'No Goods Services ~',
    '该商品暂无详情~': 'The items No details ~',
    'QQ': 'QQ',
    '新浪': 'Sina',
    '微信': 'Micro letter',
    '分享到微信': 'Share micro letter',

    //购物车页面
    '全选': 'select all',
    '商品信息': 'Product information',
    '单价': 'unit price',
    '小计（元）': '(Yuan)',
    '操作': 'operating',
    '领取优惠券': 'Receive coupons',
    '满减': 'Full cut',
    '去凑单': 'To scrape single',
    '再逛逛': 'D',
    '移入收藏夹': 'Moved Favorites',
    '删除': 'delete',
    '失效商品': 'Failure of goods',
    '失效': 'Failure',
    '已下架': 'Off the shelf',
    '删除选中的商品': 'Delete selected commodities',
    '清空失效的商品': 'Failure to clear goods',
    '已选商品': 'chosen',
    '已选择': 'chosen',
    '件商品': 'Items',
    '合计': 'total',
    '促销减': 'Save promotion',
    '去结算': 'To the settlement.',
    '确定清空失效商品？': 'Failure to determine the empty goods?',
    '取 消': 'Cancel',
    '确 定': 'OK',
    '确定删除选中商品？': 'OK to delete the selected product?',
    '剩余': 'Surplus',
    '件': 'Member',
    '确定': 'determine',
    '取消': 'cancel',
    '最低限购1件!': 'Minimum available 1!',
    '数量超出购买范围！': 'Beyond the range of the number of purchase!',
    '超过购买限制!': 'Exceed the purchase limit!',
    '不能输入非0数字!': 'You can not enter a number other than 0!',
    '移入收藏夹成功！': 'Favorites successfully moved!',
    '删除成功！': 'successfully deleted!',
    '清空失效商品成功！': 'Failure to clear merchandise success!',
    '结算商品不能为空！': 'Settlement of a commodity can not be empty!',

    //我的收藏
    '我的': 'mine',
    '收藏的商品': 'Collection of goods',
    '收藏的店铺': 'Favorite shops',
    '热门推荐': 'Hot Offers',
    '这里空空如也，快去首页逛逛吧~': 'Here empty, go home around it -',
    '去首页 > >': 'Go to Home>>',
    '已加入购物车': 'Added to Cart',
    '普通关注': 'Common concern',
    '特别关注': 'Special attention',
    ' 设为特殊关注': 'Set special attention',
    '取消特殊关注': 'Cancel special attention',
    '本月上新': 'New this month',
    '热销推荐': 'Hot Recommend',
    '取消收藏': 'Unsubscribe',
    '管理': 'management',
    '设为特殊关注': 'Set special attention',
    '您还没关注过店铺，快去': 'You have not been concerned about the store, go',
    '逛逛吧~': 'Stroll ~',
    '您还没关注过商品，快去': 'You have not been concerned about the product, go',

    //首页公共头部——搜索模块
    '请输入关键词': 'Please enter a keyword',
    '热门搜索': 'popular searches',
    '我的购物车': 'my shopping cart',
    '购物车中还没有商品，赶紧选购吧': 'Shopping cart yet commodities, and quickly buy it',

    //店铺公共头部数据——导航和店铺分类
    '综合评分': 'Overall rating',
    '店铺评分': 'Store Ratings',
    '描述相符': 'Description match',
    '服务态度': 'Service attitude',
    '服务承诺': 'Pledge',
    '正品保障': 'Genuine security',
    '发货速度': 'Delivery speed',
    '客服电话': 'consumer hotline',
    '店铺首页': 'Store Home',
    '搜本店': 'This store',
    '本店全部分类': 'All shop Category',
    '所有商品': 'All goods',
    '请输入...': 'please enter...',

    //店铺商品列表
    '件相关商品': 'Member related products',
    '共': 'Total',

    //首页装修
    '人购买': 'People buy',
    '立即抢购': 'Buy now',
    '查看更多': 'see more',
    '此处添加商品': 'Here to add commodities',
    '此处添加【360*560】图片': 'Add here [360 * 560] picture',
    '请选择商品，数量建议选择3的倍数，最少3个，最多12个': 'Select the merchandise, recommended to choose the number of multiples of three, at least 3, up to 12',
    '请上传500*80的图片': 'Please upload pictures of 500 * 80',
    '平台还未设置公告': 'Platform announcement has not been set',
    '平台还未设置资讯': 'Platform information has not been set',
    '该场景还没有商品': 'This scenario also no product',
    '请选择供货商，数量建议选择5的倍数，最少5个，最多20个': 'Please select the supplier, recommended to choose the number of multiples of five, at least five, up to 20',

    //我的足迹
    '关注': 'attention',

    //个人中心
    '待付款': '',
    '会员收货地址': 'Member shipping address',
    '我的财产': 'My property',
    '余额': 'Balance',
    '充值': 'Recharge',
    '领券': 'Collar coupons',
    '查看': 'View',
    '售后/退货': 'Sale / return',
    '进行中的订单': 'Ongoing orders',
    '去支付': 'To pay',
    '我的关注': 'my focus',
    '商品关注': 'Commodity concern',
    '店铺关注': 'Shop concern',
    '积分': 'integral',
    '这里空空如也，快去挑选合适的商品吧~': 'Here empty, go and pick the right product, right ~',
    '退款金额不可为0或者负值！': '',
    //订单列表
    '订单': 'Orders',
    '商品名称/订单编号': 'Product name / order number',
    '订单号/商品名称/店铺名称': 'Product name / order number / store name',
    '我的订单': 'My Order',
    '我的订单': 'Points order',
    '全部订单': 'All orders',
    '待支付': 'To be paid',
    '待发货': 'to be delivered',
    '待收货': 'Inbound',
    '已完成': 'completed',
    '待评价': 'comment',
    '请输入内容': 'Please enter content',
    '搜索订单': 'Search for orders',
    '售后维权': 'Sale rights',
    '订单金额': 'order amount',
    '下单时间': 'order time',
    '订单号': 'order number',
    '订单详情': 'order details',
    '普通订单': 'General orders',
    '修改地址': 'Change address',
    '查看物流': 'View Logistics',
    '确认收货': 'Confirm receipt',
    '确认收货?': 'Confirm receipt?',
    '取消订单': 'cancel order',
    '立即支付': 'pay immediately',
    '删除订单': 'Delete orders',
    '取消订单理由': 'Reason to cancel the order',
    '物流信息': 'Logistics information',
    '运单号': 'Waybill number',
    '承运人': 'Carrier',
    '联系人': 'Contacts',
    '联系电话': 'contact number',
    '更换地址': 'Replace the address',
    '收货人': 'Receiver',
    '联系方式': 'contact details',
    '收货地址': 'Shipping address',
    '提交修改': 'Submit modification',
    '切换地址成功': 'Address switching success',
    '确认删除该订单?': 'Confirm delete the order?',
    '提示': 'prompt',
    '删除订单成功': 'Delete Orders success',
    '请选择取消理由': 'Select Cancel grounds',
    '取消订单成功': 'Cancel the order success',
    '确认收货成功': 'Confirm receipt success',
    '暂无订单～': 'No orders ~',

    // 售后详情页面
    '退款退货单号': 'Refund returns a single number',
    '提交申请': 'submit application',
    '审核中': 'under review',
    '完成': 'carry out',
    '退款金额': 'The amount of the refund',
    '问题描述': 'Problem Description',
    '时间': 'time',
    '平台审核备注': 'Audit Notes platform',
    '退款凭证': 'Refund certificate',
    '退款单号': 'Refund No.',

    // 申请售后

    '添加/编辑': 'Add / Edit',
    '（同订单商品可批量申请）': '(With your order quantities may apply)',
    '退款金额可修改，最多': 'The refund amount may be modified, most',
    '退款金额不可修改，最多': 'The amount of the refund can not be modified, most',
    '含运费': 'Including freight',
    '不含运费': 'Excluding freight',
    '修改金额': 'Modify the amount',
    '申请件数': 'The number of applications',
    '请输入申请件数': 'Please enter a number of applications',
    '申请类型': 'application type',
    '货物状态': 'Cargo state',
    '退款原因': 'reason for refund',
    '请选择退款原因': 'Please select the reason for the refund',
    '退货原因': 'reason for return',
    '请选择退货原因': 'Please select the reason for the return',
    '请输入退款金额': 'Please enter the amount of the refund',
    '请输入问题描述(选填)': 'Please enter a description (optional)',
    '批量售后商品选择': 'Batch aftermarket product selection',
    '上传凭证': 'upload certificate',
    '未收到货': 'We did not receive the goods',
    '已收到货': 'We have received the goods',
    '退款退货': 'refund / return',
    '不可超出最大申请数量': 'Not exceed the maximum number of application',
    '不可超过最大退款金额！': 'Must not exceed the maximum amount of the refund!',
    '退款金额不可0或者为负值！': 'Refund amount can not be 0 or negative!',
    '最多上传5张！': 'Upload up to five!',

    // 售后列表
    '商品明细': 'Product Details',
    '申请时间': 'application time',
    '状态': 'status',
    '发货': 'Ship',
    '仅退款': 'Only refund',
    '退货退款': 'Refunds',

    // 填写物流页面
    '用户发货': 'Users delivery',
    '商品名称': 'product name',
    '购买数量': 'Purchase quantity',
    '服务类型': 'Service type',
    '快递公司': 'Express',
    '请选择快递公司': 'Please select Express',
    '快递单号': 'tracking number',
    '请输入快递单号': 'Please enter the express orders',
    '提交': 'submit',
    '请选择物流公司!': 'Please select logistics company!',
    '请输入物流单号！': 'Please enter the logistics a single number!',
    '请输入正确的物流单号！': 'Please enter the correct logistics a single number!',

    //消息中心——左侧公共菜单
    '消息列表': 'Message List',
    '系统消息': 'system information',
    '订单消息': 'Order message',
    '资产消息': 'Asset news',
    '售后消息': 'Sale message',
    '接收设置': 'Receiving settings',

    //待评订单
    '待评订单': 'Orders to be evaluated',
    '发评价，得积分，积少成多换商品': 'Evaluation of hair to give integral, exchange of goods add up',
    '评价小贴士': 'Evaluation Tips',
    '发表评价可获得会员积分': 'Reviewed obtain membership points',
    '支付金额': 'Payment amount',
    '评价订单': 'Evaluation orders',

    //订单详情
    '提交订单': 'Submit Order',
    '支付订单': 'Payment orders',
    '商家发货': 'Merchant shipping',
    '送货方式': 'Delivery methods',
    '物流公司': 'Logistics Company',
    '运单号码': 'Waybill number',
    '暂无物流信息': 'No logistics information',
    '订单信息': 'order information',
    '发票': 'invoice',
    '不需要发票': 'Invoices do not need',
    '发票抬头': 'Invoice',
    '卖家': 'Sellers',
    '收货人信息': 'recipient information',
    '商品总额': 'Total merchandise',
    '商品金额': '',
    '优惠': 'Offers',
    '运费金额': 'The amount of freight',
    '实际金额': 'The actual amount',
    '交易关闭': 'Trading closed',

    //领劵中心
    '领劵中心': 'Collar coupon center',
    '折': 'fold',
    '立即领取': 'get it right now',
    '领取': 'get it',
    '已领取': 'I have received',
    '已抢': 'It has reopened',
    '已抢光': 'We have been robbed',
    '领取成功': 'Receive success',
    //个人中心-我的优惠卷
    '我的优惠卷': 'My coupons',
    '未使用': 'Unused',
    '已使用': 'Used',
    '已失效': 'expired',
    '使用规则': 'Use rules',
    '立即使用': 'use immediately',
    //个人中心——头部公共菜单
    '消息': 'news',
    '账户管理': 'Account Management',

    //个人中心——左侧公共菜单
    '交易中心': 'Trading Center',
    '交易评价/晒单': 'Trading evaluation / single sun',
    '关注中心': 'The center of attention',
    '我的收藏': 'my collection',
    '我的足迹': 'My Tracks',
    '客户服务': 'customer service',
    '我的退款': 'My refund',
    '我的退货': 'I return',
    '会员中心': 'Member Centre',
    '会员信息': 'member information',
    '账号安全': 'Account security',
    '手机号管理': 'Phone number management',
    '邮箱管理': 'E-mail management',
    '登录密码': 'login password',
    '支付密码': 'Payment password',
    '重置密码': 'reset Password',
    '我的钱包': 'My purse',
    '我的余额': 'My balance',
    '账户充值': 'Account recharge',
    '提现账号': 'Account withdrawals',
    '我的优惠券': 'my discount coupon',

    //个人中心-我的余额
    '总金额': 'total amount',
    '可用余额': 'Available Balance',
    '余额明细': 'Balance details',
    '充值明细': 'Details recharge',
    '交易日期': 'transaction date',
    '收入/支出': 'income and expenses',
    '变动原因': 'Reasons for change',
    '充值金额': 'Recharge amount',


    //utils/common
    '请输入正确的手机号': 'please enter a valid phone number',
    '密码最少6位哦～': 'Password least six oh ~',
    '密码最多20位哦～': 'Oh password up to 20 ~',
    '密码不可以有中文哦～': 'Password not have Chinese oh',
    '密码中不可以有空格哦～': 'Password can not have spaces oh',
    '请输入短信验证码': 'Please enter the message authentication code',
    '请输入正确的短信验证码': 'Please enter the correct message authentication code',
    '请输入6～20位的会员名': 'Please enter 6 to 20 member name',
    '请输入6～会员名不能全为数字': 'Username can not be all digital',
    '会员名须由中、英文、数字、"-"及"_"组成': 'Member name shall be in English, numbers, "-" and "_" component',
    '请输入正确的图形验证码': 'Please enter the correct pattern codes',
    '该功能在升级中～': 'This feature upgrade ~',
    '请输入邮箱': 'please input your email',
    '请输入正确的邮箱': 'please enter your vaild email',

    // 消息设置
    '接收': 'receive',
    '不接收': 'Not received',

    //消息列表
    '标记已读': 'Mark Read',
    '确定删除这条消息吗？': 'OK to delete this news?',
    '查看详情 >': 'View More>',
    '暂时没有消息！': 'Buyer No news!',
    '请先选择要操作的消息！': 'Please select the message you want to operate!',

    //品牌中心
    '品牌中心': 'Brand Center',

    //充值页面
    '1.填写充值金额': '1. Fill in the amount of recharge',
    '2.在线支付': '2. Online payment',
    '3.充值完成': '3. Complete your',
    '填写充值金额': 'Fill in the amount of recharge',
    '充值账户': 'Prepaid accounts',
    '请注意：支持支付宝支付、微信支付，在线支付成功后，充值金额会在1到5分钟内到账': 'Note: support Alipay payment, micro-channel pay, after the success of online payment, recharge amount will be credited within 1-5 minutes',
    '温馨提示': 'Tips',
    '下一步': 'Next',
    '1.充值成功后，余额可能存在延迟现象，一般1到5分钟内到账，如有问题，请咨询客服；': '1. After successful recharge, balance there may be delays, usually within 1-5 minutes arrival, any questions, please contact customer service;',
    '2.充值金额输入值必须是不小于1且不大于5000；': '2. Enter the amount of prepaid value must be not less than 1 and not more than 5000;',
    '3.充值完成后，您可至会员中心查看充值记录。': '3. After the recharge is complete, you can view the recharge record to the Member Center.',
    '请使用手机微信扫描下方二维码进行支付': 'Please use the phone under the Fanger Wei code scanning micro-channel pay',
    '您正在充值余额，请尽快支付': "You're recharge balance, please pay as soon as possible",
    '应付金额': 'Amounts payable',
    '微信支付支付': 'Micro-channel based payment',
    '如二维码过期，': 'The two-dimensional code is expired,',
    '刷新': 'Refresh',
    '重新获取二维码。': 'Reacquire two-dimensional code.',
    '请输入充值金额': 'Please enter the recharge amount',
    '请选择支付方式': 'Please select the payment method',
    '充值成功,2s后自动跳转充值列表': 'Successful recharge, recharge automatically jump list after 2s',
    '立即充值': 'Recharge immediately',
    '选择充值方式': 'Recharge mode select',
    '使用微信扫码支付': 'Payment using micro-channel scan code',
    '超过充值金额上限': 'Exceed the upper limit of the amount of recharge',

    //收货地址
    '地址管理': 'Address Management',
    '默认地址': 'default address',
    '新增地址': 'New Address',
    '全部地址': 'All addresses',
    '暂无收货地址～': 'No shipping address ~',

    // 公共购物车顶部弹框组件
    '最新加入的商品': 'The latest addition to the goods',
    '去购物车': 'Go to shopping cart',

    //空页面组件
    '暂时没有数据～': 'No data to ~',

    //手机号管理
    '当前手机号': 'Current phone number',
    '请输入新手机号': 'Please enter a new phone number',
    '为了保障您的账号安全，变更重要信息需进行身份验证。': 'To protect your account security, change critical information required for authentication.',
    '变更过程中有任何疑问请联系在线客服解决。': 'Change process have any questions please contact the online customer service to solve.',
    '如手机号/邮箱已不再使用无法获取验证码，请联系在线客服解决。': 'Such as phone number / mailbox no longer in use can not get a verification code, please contact the online customer service to solve.',

    //邮箱管理
    '请输入邮箱号': 'Please enter the mailbox number',
    '请输入邮箱验证码': 'Please enter the mailbox codes',
    '请输入正确的邮箱验证码': 'Please enter a valid email address Verification Code',

    //设置登陆密码
    '复杂的密码可使账号更安全且建议定期更换密码。': 'Complex passwords make accounts more secure, and is recommended to change your password regularly.',

    //个人中心--会员信息
    '仅支持JPG、GIF、PNG格式；文件大小请在1.0MB之内。': 'Only supports JPG, GIF, PNG format; please file size of 1.0MB within.',
    '会员名：': 'Username:',
    '性别：': 'gender:',
    '保密': 'Confidentiality',
    '男': 'male',
    '女': 'Female',
    '昵称：': 'nickname:',
    '生日：': 'birthday:',
    '年': 'year',
    '月': 'month',
    '日': 'day',
    '保存': 'save',

    //收货地址
    '设置为默认': 'Set as default',
    '删除地址': 'Delete address',
    '编辑地址': 'Edit address',

    //我的积分
    '日期': 'date',
    '详细说明': 'Detailed description',
    '可用积分': 'Points Available',
    '收入': 'income',
    '支出': 'expenditure',

    //确认下单页
    '确认订单': '',
    '付款': '',
    '支付成功': '',
    '收货信息': '',
    '收货人': '',
    '联系方式': '',
    '收货地址': '',
    '更换地址': '',
    '新建地址': '',
    '新增收货地址': '',
    '赠品': '',
    '赠完为止': '',
    '优惠券使用': '',
    '暂无可用优惠券': '',
    '不使用优惠券': '',
    '发票': '',
    '重新选择': '',
    '订单备注': '',
    '给商家留言': '',
    '选填，给卖家留言备注': '',
    '商品清单':'',
    '返回修改购物车':'',
    '商品合计': '',
    '优惠': '',
    '运费': '',
    '平台优惠券': '',
    '使用优惠券/积分抵用':'',
    '积分抵扣': '',
    '可用积分': '',
    '积分抵现': '',
    '当前积分': '',
    '我要开发票': '',
    '实付款（含运费）': '',
    '商品总额(含运费)': '',
    '送货至': '',
    '优惠了': '',
    '共优惠': '',
    '去付款': '',
    '发票历史信息选择': '',
    '默认': '',
    '新增发票': '',
    '暂不开发票': '',
    '发票内容': '',
    '商品明细': '',
    '商品类别': '',
    '发票内容将显示商品名称与价格信息，发票金额为实际支付金额，不含优惠等扣减金额': '',
    '发票内容将显示本单商品所属类别及价格信息，发票金额为实际支付金额，不含优惠等扣减金额。': '',
    '发票抬头': '',
    '个人': '',
    '公司': '',
    '发票类型': '',
    '普通发票': "",
    '增值税专用发票': '',
    '单位名称': '',
    '请在此填写单位名称': '',
    '税号': '',
    '请在此填写纳税人识别号': '',
    "请输入注册地址": '',
    "请输入注册电话": '',
    "请输入开户银行": '',
    "请输入银行账户": '',
    "请输入收票人姓名": "",
    "请输入收票人电话": "",
    "请输入收票人地址": "",
    '收票邮箱': '',
    "设为默认发票": '',
    "返回": "",
    "确定": '',
    "返回": '',
    '移除无货商品': '',
    '收货人': '',
    '联系方式': '',
    '提交修改': '',
    '使用积分': '',
    '可用积分': '',
    '使用': '',
    '抵扣': '',
    '积分': '',
    '暂不使用积分': '',
    '订单大于': '',
    '元': '',
    '可用': '',
    '积分支付不超过订单金额的': '',
    '积分等于': '',
    "请填写发票抬头": '',
    "请填写收票邮箱": '',
    "邮箱格式不正确，请重新输入！": '',
    "请填写单位名称": '',
    "请填写纳税人税号": "",
    "请填写正确的税号": '',
    "请填写收票邮箱": '',
    "请填写注册地址": "",
    "请填写注册电话": "",
    "请填写开户银行": "",
    "请填写银行账户": '',
    "请填写收票人姓名": "",
    "请填写收票人电话": '',
    "请填写收票人地址": '',
    "提交订单失败，请稍后重试": '',
    ",2s后自动跳转订单列表": "",

};
